export const localStorageEffect =
  (key: string) =>
  ({ setSelf, onSet }: any) => {
    if (typeof window === 'undefined') {
      return;
    }
    const savedValue = localStorage.getItem(key);
    if (savedValue !== null && savedValue !== 'undefined') {
      setSelf(JSON.parse(savedValue));
    }
    onSet((newValue: any, _: any, isReset: boolean) => {
      isReset ? localStorage.removeItem(key) : localStorage.setItem(key, JSON.stringify(newValue));
    });
  };
export const sessionStorageEffect =
  (key: string) =>
  ({ setSelf, onSet }: any) => {
    if (typeof window === 'undefined') {
      return;
    }
    const savedValue = sessionStorage.getItem(key);
    if (savedValue !== null) {
      setSelf(JSON.parse(savedValue));
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onSet((newValue: any, _: any, _isReset: any) => {
      const confirm = newValue.length === 0;
      confirm ? sessionStorage.removeItem(key) : sessionStorage.setItem(key, JSON.stringify(newValue));
    });
  };
